/**
 * INTERCEPTOR — cartridge palette.
 *
 * '84 arcade pursuit aesthetic, distinct from NEON OVERPASS's vaporwave
 * sunset. Cooler tones: night-asphalt road, white lane markings, blue
 * player, red enemies. Civilian cars in muted colors so the threat
 * vehicles read against the crowd.
 */

// Road surface.
export const ROAD_DARK = '#1a1a24';
export const ROAD_LIGHT = '#22222e';
export const ROAD_EDGE = '#3a3a48';
export const LANE_MARK = '#e8e8f0';
export const SHOULDER_GRASS = '#0a1a08';

// Player vehicle.
export const PLAYER_BODY = '#ffea00';
export const PLAYER_BODY_DARK = '#a08a00';
export const PLAYER_WINDOW = '#00d9ff';
export const PLAYER_WINDOW_HI = '#bff7ff';
export const PLAYER_TAIL = '#ff3030';

// Civilian traffic — muted, so the enemy vehicles pop.
export const CIVILIAN_BLUE = '#3a5a8a';
export const CIVILIAN_GREEN = '#4a7050';
export const CIVILIAN_WHITE = '#c0c0c8';
export const CIVILIAN_GRAY = '#6a6a78';

// Enemy: Switchblade — bright threatening yellow-orange that reads against
// the civilian palette and the player's yellow body (different hue so the
// player doesn't get confused for an enemy).
export const SWITCHBLADE_BODY = '#ff8a00';
export const SWITCHBLADE_DARK = '#a05800';
export const SWITCHBLADE_HEADLIGHT = '#ffea00';
export const SWITCHBLADE_WARNING = '#ff3030';

// HUD.
export const HUD_TEXT = '#7af3c8';
export const HUD_SCORE = '#ffea00';
export const HUD_DISTANCE = '#00d9ff';
export const HUD_ENEMY = '#ff8a00';

// Effects.
export const CRASH_FLASH = '#ff3030';

/** Tokens the cabinet samples for marquee tinting while this cartridge is loaded. */
export const PALETTE_HINT: readonly string[] = [
  SWITCHBLADE_BODY,
  PLAYER_WINDOW,
  PLAYER_BODY,
  CRASH_FLASH,
];
